module.exports = __webpack_public_path__ + "img/swip-img.c20ea9a5.png";